module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/2@2x_1a32e923a4e0650545db36113a9247bb.png";